import { ShopCaseBanner } from "../features/shop/ShopCaseBanner.jsx";
import { UserAgreementPage } from "./UserAgreementPage.jsx";
import "./ShopPage.css";
import { getAuthData } from "../features/auth/session.js";
// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import { Ii } from "../assets.jsx";
import { jn } from "../assets.jsx";
import { Ns } from "../assets.jsx";
import { IconBox } from "../components/icons.jsx";
import { IconDiamond } from "../components/icons.jsx";
import * as React from "react";
import * as jsxRuntime from "react/jsx-runtime";
import { ResourceSummaryStrip } from "../components/ResourceSummaryStrip.jsx";
import { IconCards } from "../components/icons.jsx";
import { $m } from "../assets.jsx";
import { Km } from "../assets.jsx";
import { IconGift } from "../components/icons.jsx";
import { IconStarFilledFilled } from "../FishingArcade.jsx";
import { IconX, IconCreditCard } from "../components/icons.jsx";
const MetaCoinEmoji = ({ size = 16, ...props }) => jsxRuntime.jsx("img", {
  src: "/assets/resource-emojis/coin.webp",
  alt: "",
  width: size,
  height: size,
  ...props
});
export const S_ = "_shop_1jcbh_1";
export const w_ = "_tabs_1jcbh_7";
export const N_ = "_active_1jcbh_11";
export const T_ = "_sectionHeading_1jcbh_13";
export const C_ = "_currency_1jcbh_21";
export const M_ = "_quantity_1jcbh_23";
export const A_ = "_cases_1jcbh_33";
export const E_ = "_caseCard_1jcbh_35";
export const D_ = "_limited_1jcbh_37";
export const z_ = "_mystic_1jcbh_39";
export const O_ = "_caseArt_1jcbh_41";
export const k_ = "_caseInfo_1jcbh_49";
export const R_ = "_caseTag_1jcbh_51";
export const B_ = "_buy_1jcbh_57";
export const U_ = "_topUp_1jcbh_63";
export const H_ = "_footnote_1jcbh_67";
export const L_ = "_notice_1jcbh_71";
export const q_ = "_back_1jcbh_73";
export const G_ = "_resourceList_1jcbh_75";
export const Y_ = "_resourceGroup_1jcbh_77";
export const X_ = "_resourceRow_1jcbh_81";
export const Q_ = "_valueLabel_1jcbh_93";
export const Z_ = "_bonusBanner_1jcbh_95";
export const V_ = "_coinGrid_1jcbh_105";
export const $_ = "_coinCard_1jcbh_107";
export const K_ = "_coinArt_1jcbh_109";
export const J_ = "_packageNumber_1jcbh_121";
export const W_ = "_custom_1jcbh_129";
export const I_ = "_promotion_1jcbh_143";
export const F_ = "_badge_1jcbh_147";
export const P_ = "_promoPrice_1jcbh_153";
export const e2 = "_balances_1jcbh_161";
export const Ue = {
  shop: S_,
  tabs: w_,
  active: N_,
  sectionHeading: T_,
  currency: C_,
  quantity: M_,
  cases: A_,
  caseCard: E_,
  limited: D_,
  mystic: z_,
  caseArt: O_,
  caseInfo: k_,
  caseTag: R_,
  buy: B_,
  topUp: U_,
  footnote: H_,
  notice: L_,
  back: q_,
  resourceList: G_,
  resourceGroup: Y_,
  resourceRow: X_,
  valueLabel: Q_,
  bonusBanner: Z_,
  coinGrid: V_,
  coinCard: $_,
  coinArt: K_,
  packageNumber: J_,
  custom: W_,
  promotion: I_,
  badge: F_,
  promoPrice: P_,
  balances: e2
};
export const gm = [{
  id: "light",
  title: "LIGHT",
  subtitle: "Полезные ресурсы для новых открытий",
  tag: "Ресурсы",
  price: 30,
  image: Ii
}, {
  id: "limited",
  title: "LIMITED",
  subtitle: "Шанс найти лимитную карту",
  tag: "Лимитные карты",
  price: 70,
  image: jn
}, {
  id: "mystic",
  title: "MYSTIC",
  subtitle: "Редкие награды и шанс на Mystic карту",
  tag: "Мистическая коллекция",
  price: 200,
  image: Ns
}];
export const ym = {
  spins: [{
    amount: 5,
    price: 30
  }, {
    amount: 10,
    price: 50
  }, {
    amount: 30,
    price: 145
  }, {
    amount: 100,
    price: 470
  }, {
    amount: 500,
    price: 2250
  }, {
    amount: 2e3,
    price: 8400
  }],
  crystals: [{
    amount: 1e3,
    price: 25
  }, {
    amount: 3e3,
    price: 70
  }, {
    amount: 1e4,
    price: 200
  }, {
    amount: 25e3,
    price: 500
  }, {
    amount: 1e5,
    price: 2e3
  }, {
    amount: 5e5,
    price: 1e4
  }]
};
export const _m = [{
  coins: 30,
  stars: 20
}, {
  coins: 100,
  stars: 50
}, {
  coins: 500,
  stars: 250
}, {
  coins: 1e3,
  stars: 500
}, {
  coins: 2e3,
  stars: 1e3
}, {
  coins: 1e4,
  stars: 5e3
}];
export const vt = u => u.toLocaleString("ru-RU", {
  maximumFractionDigits: 2
});
export const t2 = [{
  id: "cases",
  label: "Кейсы",
  icon: IconBox
}, {
  id: "resources",
  label: "Ресурсы",
  icon: IconDiamond
}, {
  id: "metacoins",
  label: "MetaCoin",
  icon: MetaCoinEmoji
}];
export function ShopPage({
  balance: u,
  resources: o,
  onBuyMetaCoins: m,
  onBuyCase: r,
  onBuyPromotion: g,
  onBuyResource: j
}) {
  const [B, U] = React.useState(() => {
      const T = sessionStorage.getItem("metacard-shop-section");
      return T === "metacoins" ? T : T === "resources" || T === "spins" || T === "crystals" ? "resources" : "cases";
    }),
    [N, y] = React.useState(null),
    [R, H] = React.useState(""),
    Y = React.useRef(!1),
    [P, W] = React.useState(""),
    [w, I] = React.useState([]);
  const [agreementOpen, setAgreementOpen] = React.useState(false);
  const closeAgreement = React.useCallback(() => setAgreementOpen(false), []);
  React.useEffect(() => {
    const T = getAuthData();
    if (!T) return;
    const D = new AbortController(),
      le = window.setTimeout(() => D.abort(), 1e4);
    return fetch("/api/shop/state", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        initData: T
      }),
      signal: D.signal
    }).then(te => te.ok ? te.json() : null).then(te => {
      D.signal.aborted || (I((te?.promotions || []).filter(Z => Z.remaining_purchases > 0)), y(te?.coinOffer || null));
    }).catch(() => {}).finally(() => window.clearTimeout(le)), () => {
      D.abort(), window.clearTimeout(le);
    };
  }, [u]), React.useEffect(() => {
    sessionStorage.setItem("metacard-shop-section", B);
  }, [B]);
  const ne = async (T, D, le) => {
      if (!Y.current) {
        if (u < D) {
          W(""), U("metacoins");
          return;
        }
        Y.current = !0, H(T), W("");
        try {
          await le();
        } catch {
          W("Не удалось выполнить покупку. Попробуйте ещё раз.");
        } finally {
          Y.current = !1, H("");
        }
      }
    },
    oe = async T => {
      await ne(`promotion:${T.id}`, T.price, async () => {
        const D = await g(T.id);
        return D && I(le => le.flatMap(te => te.id !== T.id ? [te] : te.remaining_purchases > 1 ? [{
          ...te,
          remaining_purchases: te.remaining_purchases - 1
        }] : [])), D;
      });
    };
  return jsxRuntime.jsxs("section", {
    className: `${Ue.shop} mc-game-shop`,
    "aria-label": "Магазин",
    children: [jsxRuntime.jsx(ResourceSummaryStrip, {
      metacoins: u,
      resources: o,
      className: Ue.balances
    }), jsxRuntime.jsx("nav", {
      className: Ue.tabs,
      "aria-label": "Разделы магазина",
      children: t2.map(({
        id: T,
        label: D,
        icon: le
      }) => jsxRuntime.jsxs("button", {
        "aria-pressed": B === T,
        className: B === T ? Ue.active : "",
        onClick: () => {
          U(T), W("");
        },
        children: [jsxRuntime.jsx(le, {
          size: 23
        }), jsxRuntime.jsx("span", {
          children: D
        })]
      }, T))
    }), P && jsxRuntime.jsx("p", {
      className: Ue.notice,
      role: "status",
      children: P
    }), B === "cases" && jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [w.map(T => jsxRuntime.jsxs("article", {
        className: Ue.promotion,
        children: [jsxRuntime.jsxs("div", {
          children: [jsxRuntime.jsx("span", {
            className: Ue.badge,
            children: T.badge
          }), jsxRuntime.jsx("h2", {
            children: T.title
          }), jsxRuntime.jsx("p", {
            children: T.description
          }), jsxRuntime.jsxs("div", {
            className: Ue.promoPrice,
            children: [T.original_price && T.original_price > T.price ? jsxRuntime.jsxs("s", {
              children: [vt(T.original_price), " MC"]
            }) : null, jsxRuntime.jsxs("strong", {
              children: [vt(T.price), " MC"]
            })]
          }), jsxRuntime.jsx("button", {
            className: Ue.buy,
            disabled: !!R,
            onClick: () => {
              oe(T);
            },
            children: R === `promotion:${T.id}` ? "Покупаем…" : u < T.price ? "Пополнить баланс" : `Купить ×${T.case_amount}`
          })]
        }), jsxRuntime.jsx("img", {
          src: gm.find(D => D.id === T.image_key)?.image || jn,
          alt: ""
        })]
      }, T.id)), jsxRuntime.jsx("div", {
        className: Ue.cases,
        children: gm.map(caseItem => jsxRuntime.jsx(ShopCaseBanner, {
          caseItem, balance: u, busy: !!R, pending: R,
          onPurchase: amount => ne(`case:${caseItem.id}:${amount}`, caseItem.price * amount, () => r(caseItem.id, amount))
        }, caseItem.id))
      })]
    }), B === "resources" && jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [["spins", "crystals"].map(T => {
        const best = [...ym[T]].sort((a, b) => a.price / a.amount - b.price / b.amount || b.amount - a.amount)[0];
        return jsxRuntime.jsxs("section", {
        className: Ue.resourceGroup,
        "aria-label": T === "spins" ? "Крутки" : "Кристаллы",
        children: [jsxRuntime.jsxs("h2", {
          children: [T === "spins" ? jsxRuntime.jsx(IconCards, {
            size: 17
          }) : jsxRuntime.jsx(IconDiamond, {
            size: 17
          }), T === "spins" ? "Крутки" : "Кристаллы"]
        }), jsxRuntime.jsx("div", {
          className: Ue.resourceList,
          children: ym[T].map(D => {
            const le = `${T}:${D.amount}`,
              isBest = D.amount === best.amount,
              ge = (D.price / D.amount).toLocaleString("ru-RU", {
                maximumFractionDigits: T === "spins" ? 2 : 3
              });
            return jsxRuntime.jsxs("article", {
              className: `${Ue.resourceRow}${isBest ? " mc-resource-row-best" : ""}`,
              children: [jsxRuntime.jsx("img", {
                src: T === "spins" ? $m : Km,
                alt: ""
              }), jsxRuntime.jsxs("div", {
                children: [isBest && jsxRuntime.jsx("span", {
                  className: "mc-resource-best-label",
                  children: "Выгоднее всех"
                }), jsxRuntime.jsx("h3", {
                  children: vt(D.amount)
                }), jsxRuntime.jsx("small", {
                  children: `${ge} MC за ${T === "spins" ? "крутку" : "кристалл"}`
                })]
              }), jsxRuntime.jsxs("button", {
                className: Ue.buy,
                disabled: !!R,
                "aria-label": `Купить ${vt(D.amount)} ${T === "spins" ? "круток" : "кристаллов"} за ${D.price} MetaCoin`,
                onClick: () => {
                  ne(le, D.price, () => j(T, D.amount));
                },
                children: [jsxRuntime.jsxs("strong", {
                  children: [jsxRuntime.jsx(MetaCoinEmoji, {
                    size: 16
                  }), vt(D.price)]
                })]
              })]
            }, le);
          })
        })]
      }, T);
      })]
    }), B === "metacoins" && jsxRuntime.jsx(MetaCoinShop, {
      onBuy: m,
      offer: N
    }), jsxRuntime.jsx("p", {
      className: "mc-shop-agreement-note",
      children: ["Совершая покупку, вы принимаете ", jsxRuntime.jsx("button", {
        type: "button",
        onClick: () => setAgreementOpen(true),
        children: "Пользовательское соглашение"
      }), "."]
    }), agreementOpen && jsxRuntime.jsx(UserAgreementPage, {
      onClose: closeAgreement
    })]
  });
}
export function MetaCoinShop({
  onBuy: u,
  offer: o
}) {
  const m = o?.multiplier === 2 ? 2 : 1,
    [r, g] = React.useState(""),
    [j, B] = React.useState(null),
    [payment, setPayment] = React.useState(null),
    [method, setMethod] = React.useState("stars"),
    [email, setEmail] = React.useState(""),
    U = React.useRef(!1),
    [N, y] = React.useState(""),
    X = async (Y, P = !1, selectedMethod = "stars") => {
      if (!U.current) {
        U.current = !0, B(Y), y("");
        try {
          await u(Y, P, selectedMethod, email.trim());
        } catch (error) {
          y(error instanceof Error ? error.message : "Не удалось открыть счёт. Попробуйте ещё раз.");
        } finally {
          U.current = !1, B(null);
        }
      }
    },
    M = Number(r),
    R = Number.isInteger(M) && M >= 1 && M <= 1e5,
    choosePayment = (coins, custom = !1) => setPayment({ coins, custom }),
    payWithStars = () => {
      if (!payment || j !== null) return;
      const selected = payment;
      setPayment(null);
      X(selected.coins, selected.custom, method);
    },
    selectedStars = payment ? _m.find(Y => Y.coins === payment.coins)?.stars ?? Math.ceil(payment.coins / 2) : 0;
  React.useEffect(() => {
    if (!payment) return;
    const closeOnEscape = event => event.key === "Escape" && setPayment(null);
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [payment]);
  return jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [m === 2 && jsxRuntime.jsxs("div", {
      className: Ue.bonusBanner,
      children: [jsxRuntime.jsx(IconGift, {
        size: 28
      }), jsxRuntime.jsxs("div", {
        children: [jsxRuntime.jsx("b", {
          children: o?.title
        }), jsxRuntime.jsx("p", {
          children: o?.kind === "first" ? "Один раз на аккаунт. Получи вдвое больше MetaCoin." : "Вдвое больше MetaCoin на время акции."
        })]
      }), jsxRuntime.jsx("strong", {
        children: "×2"
      })]
    }), N && jsxRuntime.jsx("p", {
      className: Ue.notice,
      role: "alert",
      children: N
    }), jsxRuntime.jsx("div", {
      className: Ue.coinGrid,
      children: _m.map((Y, P) => jsxRuntime.jsxs("article", {
        className: Ue.coinCard,
        children: [jsxRuntime.jsxs("div", {
          className: Ue.coinArt,
          "aria-hidden": "true",
          children: [jsxRuntime.jsx(MetaCoinEmoji, {}), jsxRuntime.jsx(MetaCoinEmoji, {}), jsxRuntime.jsx(MetaCoinEmoji, {})]
        }), jsxRuntime.jsxs("div", {
          className: "mc-coin-details",
          children: [jsxRuntime.jsx("h3", {
            children: vt(Y.coins * m)
          }), jsxRuntime.jsx("small", {
            children: m === 2 ? `${vt(Y.coins)} + ${vt(Y.coins)} в подарок` : "Курс: 1 MC = 1 ₽"
          })]
        }), jsxRuntime.jsx("button", {
          className: Ue.buy,
          disabled: j !== null,
          "aria-label": `Выбрать оплату для ${vt(Y.coins * m)} MetaCoin за ${vt(Y.coins)} рублей`,
          onClick: () => {
            choosePayment(Y.coins);
          },
          children: j === Y.coins ? "Открываем…" : jsxRuntime.jsx("strong", {
            children: `${vt(Y.coins)} ₽`
          })
        }), jsxRuntime.jsxs("span", {
          className: Ue.packageNumber,
          "aria-hidden": "true",
          children: ["0", P + 1]
        })]
      }, Y.coins))
    }), jsxRuntime.jsxs("form", {
      className: Ue.custom,
      onSubmit: Y => {
        Y.preventDefault(), R && choosePayment(M, !0);
      },
      children: [jsxRuntime.jsx("label", {
        htmlFor: "custom-metacoins",
        children: "Нужно другое количество?"
      }), jsxRuntime.jsxs("div", {
        children: [jsxRuntime.jsx("input", {
          id: "custom-metacoins",
          "aria-describedby": "custom-coin-help",
          inputMode: "numeric",
          type: "number",
          min: "1",
          max: "100000",
          step: "1",
          placeholder: "Количество MC",
          value: r,
          onChange: Y => g(Y.target.value)
        }), jsxRuntime.jsxs("button", {
          className: Ue.buy,
          type: "submit",
          disabled: !R || j !== null,
          children: R ? `${vt(M)} ₽` : "Купить"
        })]
      }), jsxRuntime.jsxs("small", {
        id: "custom-coin-help",
        children: [R && m === 2 && jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: ["Получишь ", vt(M * m), " MC с бонусом. "]
        }), "Курс: 1 MC = 1 ₽. Картой, через СБП или звёздами Telegram."]
      })]
    }), payment && jsxRuntime.jsx("div", {
      className: "mc-coin-payment-backdrop",
      onClick: event => event.target === event.currentTarget && setPayment(null),
      children: jsxRuntime.jsxs("section", {
        className: "mc-coin-payment-sheet",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "mc-coin-payment-title",
        children: [jsxRuntime.jsxs("header", {
          className: "mc-coin-payment-header",
          children: [jsxRuntime.jsx("h2", { id: "mc-coin-payment-title", children: "Оплата" }), jsxRuntime.jsx("button", {
            type: "button", onClick: () => setPayment(null), "aria-label": "Закрыть окно оплаты", children: jsxRuntime.jsx(IconX, { size: 20 })
          })]
        }), jsxRuntime.jsxs("div", {
          className: "mc-coin-payment-product",
          children: [jsxRuntime.jsx(MetaCoinEmoji, { size: 42 }), jsxRuntime.jsxs("div", {
            children: [jsxRuntime.jsx("strong", { children: `${vt(payment.coins * m)} MetaCoin` }), m === 2 ? jsxRuntime.jsx("small", { children: `${vt(payment.coins)} + ${vt(payment.coins)} в подарок` }) : null]
          })]
        }), jsxRuntime.jsxs("div", {
          className: "mc-coin-payment-methods",
          children: [jsxRuntime.jsxs("button", {
            type: "button", onClick: () => setMethod("stars"),
            "aria-pressed": method === "stars",
            className: `mc-coin-payment-method ${method === "stars" ? "selected" : ""}`,
            children: [jsxRuntime.jsx("span", { className: "mc-coin-payment-radio", "aria-hidden": "true" }), jsxRuntime.jsx(IconStarFilledFilled, { size: 17 }), jsxRuntime.jsxs("span", {
              children: [jsxRuntime.jsx("strong", { children: "Звёздами Telegram" }), jsxRuntime.jsx("small", { children: "С баланса звёзд" })]
            }), jsxRuntime.jsxs("b", { children: [vt(selectedStars), " ★"] })]
          }), jsxRuntime.jsxs("button", {
            type: "button", className: `mc-coin-payment-method ${method === "tbank" ? "selected" : ""}`,
            onClick: () => setMethod("tbank"), "aria-pressed": method === "tbank",
            children: [jsxRuntime.jsx("span", { className: "mc-coin-payment-radio", "aria-hidden": "true" }), jsxRuntime.jsx(IconCreditCard, { size: 18 }), jsxRuntime.jsxs("span", {
              children: [jsxRuntime.jsx("strong", { children: "Картой / СБП" }), jsxRuntime.jsx("small", { children: "На странице Т‑Банка" })]
            }), jsxRuntime.jsxs("b", { children: [vt(payment.coins), " ₽"] })]
          })]
        }), method === "tbank" && jsxRuntime.jsxs("label", {
          className: "mc-coin-payment-email",
          children: ["Электронная почта для чека", jsxRuntime.jsx("input", {
            type: "email", value: email, maxLength: 64, autoComplete: "email",
            placeholder: "mail@example.com", onChange: event => setEmail(event.target.value)
          })]
        }), jsxRuntime.jsxs("div", {
          className: "mc-coin-payment-total",
          children: ["Цена пакета: ", vt(payment.coins), " ₽ · курс 1 MC = 1 ₽"]
        }), jsxRuntime.jsxs("button", {
          type: "button", className: "mc-coin-payment-confirm", onClick: payWithStars,
          disabled: j !== null || (method === "tbank" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())),
          children: method === "tbank" ? `Оплатить ${vt(payment.coins)} ₽` : ["Оплатить ", vt(selectedStars), " ", jsxRuntime.jsx(IconStarFilledFilled, { size: 17 })]
        })]
      })
    })]
  });
}
